import React from "react";
import styled from "styled-components";

const RequiredStar: React.FC = () => {
  return <StyledStar>*</StyledStar>;
};
const StyledStar = styled.div`
  margin-left: 4px;
  color: red;
`;
export default RequiredStar;
